import { Component, OnInit } from '@angular/core';
import { LottieComponent } from '../../components/lottie/lottie.component';
import { RouterLink } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  standalone: true,
  imports: [LottieComponent, SharedModule, RouterLink],
})
export class AboutUsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  redirectToWhatsApp() {
    window.location.href = 'https://wa.me/5547992157013';
  }
}
